import React, { FunctionComponent, ReactNode } from 'react';
import { NewsTypes, WrapVideoTypes } from '../../interfaces/interfaces';
import { ArticleBar } from './wrapStyles';

export const Layout: FunctionComponent<{ children: ReactNode }> = props => {
  return (
    <ArticleBar>
      <div className="wrapUp">{props.children}</div>
    </ArticleBar>
  );
};

export const News: FunctionComponent<{
  news: NewsTypes;
}> = props => {
  return (
    <>
      <h1 className="titlehead">NEWS</h1>
      {props.news.map((n: NewsTypes) => (
        <div className="artImage">
          <a href={n.link} style={{ color: '#000' }} target="_blank">
            <img src={n.image} alt={n.alt} className="artImage" />
            {n.excerpt}
          </a>
        </div>
      ))}
    </>
  );
};

export const Videos: FunctionComponent<{
  videos: WrapVideoTypes;
}> = props => {
  return (
    <>
      <h1 className="titlehead">VIDEOS</h1>
      <div className="vidGrid">
        {props.videos.map((video: WrapVideoTypes) => (
          <div className="wrapVid">
            <iframe
              width="100%"
              className="innerVid"
              src={`https://www.youtube.com/embed/${video.link}`}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            {video.speakers && (
              // If we just want to do a non-oxford simple comma seperation, that would be much easier and could just be a .join(", ") right after mapping the first and last names
              <span className="speakName">
                {(() => {
                  const names = video.speakers.map(speaker => {
                    const {
                      person: { first_name, last_name }
                    } = speaker;
                    return `${first_name} ${last_name}`;
                  });

                  switch (names.length) {
                    case 1:
                      // Only one speaker, just return the name
                      return names[0];
                    case 2:
                      // Two speakers, join with " and "
                      return `${names[0]} and ${names[1]}`;
                    default:
                      // More than two speakers, join all with commas, but replace the last comma with ", and "
                      const lastSpeaker = names.pop(); // Removes and returns the last element
                      return `${names.join(', ')}, and ${lastSpeaker}`;
                  }
                })()}
              </span>
            )}

            <br />
            <span className="speakTitle">{video.title}</span>
          </div>
        ))}
      </div>
    </>
  );
};
export const Recap: FunctionComponent<{ recapVideoHeader:string, recapVideoId: string, recapVideoProvider:string  }> = props => {
  return (
    <>
      <a id="recap" className="anchor"></a>
      <h1 className="titlehead">{props.recapVideoHeader}</h1>
      <div className="wrapOne">
      {props.recapVideoProvider =="youtube" && <iframe width="100%" height="580px" src={`https://www.youtube.com/embed/${props.recapVideoId}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe> }
      {props.recapVideoProvider =="vimeo" && <iframe src={`https://player.vimeo.com/video/${props.recapVideoId}`} width="100%" height="580px" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture"></iframe>}
      </div>
    </>
  );
};
export const Photos: FunctionComponent<{ album: string }> = props => {
  return (
    <>
      <a id="photos" className="anchor"></a>
      <h1 className="titlehead">PHOTOS</h1>
      <div className="wrapOne">
        <iframe
          allowFullscreen=""
          frameborder="0"
          mozallowfullscreen=""
          msallowfullscreen=""
          oallowfullscreen=""
          src={`https://www.flickr.com/photos/fedscoop/albums/${props.album}/player`}
          webkitallowfullscreen=""
          width="100%"
          height="580"
          style={{ maxWidth: 1290 }}
        ></iframe>
      </div>
    </>
  );
};
